import { Stack } from '@chakra-ui/react';

import { FEED_ANALYSIS_NAV } from '../../../../pages/Dashboard/FeedAnalysis/MobileNav';
import { NavLink } from '../NavLink';
import { NavSection } from '../NavSection';

export function SidebarNavFeedAnalysis() {
  const [menu, ...items] = FEED_ANALYSIS_NAV;

  return (
    <Stack spacing="12" align="flex-start">
      <NavSection title="GERAL">
        <NavLink to={menu.to} icon={menu.icon}>
          {menu.label}
        </NavLink>
      </NavSection>

      <NavSection title="ANÁLISES DE RAÇÃO">
        {items.map(item => (
          <NavLink key={item.to} to={item.to} icon={item.icon}>
            {item.label}
          </NavLink>
        ))}
      </NavSection>
    </Stack>
  );
}
